import BackArrow from '@/app/components/questionnaireV2/icons/back-arrow';

interface StickyFooterBarProps {
  variant: 'light' | 'dark';
  onBack?: () => void;
  isBackDisabled?: boolean;
  topContent?: React.ReactNode;
  children?: React.ReactNode;
}

export function StickyFooterBar({
  variant,
  onBack,
  isBackDisabled = false,
  topContent,
  children,
}: StickyFooterBarProps) {
  const isLight = variant === 'light';

  return (
    <div
      className={`sticky bottom-0 z-20 flex w-full shrink-0 flex-col items-center px-5 pb-safe-offset-4 pt-3 ${
        isLight
          ? 'bg-white'
          : 'bg-gradient-to-t from-black/80 to-transparent'
      }`}
    >
      <div className="mx-auto flex w-full max-w-lg flex-col gap-2">
        {/* Content above buttons (skip, error, deselect) */}
        {topContent}

        {/* Back + CTA row */}
        <div className="flex w-full items-stretch gap-2">
          {onBack && (
            <button
              onClick={onBack}
              disabled={isBackDisabled}
              className={`inline-flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full border transition-colors ${
                isLight
                  ? 'border-gray-200 bg-white text-gray-400 hover:border-gray-300 hover:text-gray-600 disabled:opacity-40'
                  : 'border-white/20 bg-white/10 text-white/60 hover:bg-white/20 disabled:opacity-40'
              }`}
              style={{
                cursor: isBackDisabled ? 'not-allowed' : 'pointer',
                pointerEvents: isBackDisabled ? 'none' : 'auto',
              }}
            >
              <BackArrow />
            </button>
          )}

          {/* CTA button area - fills remaining width */}
          <div className="flex min-w-0 flex-1 [&_button]:w-full [&_button]:rounded-full">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
